import { loadTheme, IPartialTheme, ITheme, ThemeProvider } from '@fluentui/react';
import { useMemo, useEffect } from 'react';
import { DefaultTheme } from '../../../Theme/DefaultTheme';
import { TeamsDarkTheme } from '../../../Theme/TeamsDarkTheme';
import { TeamsTheme } from '../../../Theme/TeamsTheme';
import { useUiContext } from '../UIContext/uiCtx';

export const TimeThemeProvider = ({ children }: { children?: React.ReactNode }) => {
    const { isDarkmode, isTeams, isInIframe } = useUiContext();
    const theme = useMemo(() => {
        if (isInIframe && !isTeams) {
            return DefaultTheme;
        }
        if (isDarkmode) {
            return TeamsDarkTheme;
        }
        if (isTeams) {
            return TeamsTheme;
        }
        return DefaultTheme;
    }, [isDarkmode, isTeams, isInIframe]);
    useEffect(() => {
        loadTheme(theme);
        // hotfix/polyfil for theme as css variables
        const applyThemeCssVariables = (theme: IPartialTheme) => {
            const themeprovider = document.getElementById('themeprovider');
            const apply = (theme: IPartialTheme, keyName: keyof ITheme) => {
                Object.entries(theme[keyName]).forEach(([key, value]: [string, string]) => {
                    themeprovider.style.setProperty(`--${keyName}-${key}`, value);
                });
            };
            apply(theme, 'palette');
            apply(theme, 'semanticColors');
            apply(theme, 'effects');
            apply(theme, 'spacing');
        };
        applyThemeCssVariables(theme);
    }, [isDarkmode, isTeams, theme]);

    return (
        <ThemeProvider id="themeprovider" theme={theme} className={`root${isDarkmode ? ' isDarkmode' : ''}`}>
            {children}
        </ThemeProvider>
    );
};
